export default "/assets/images/mila-feed-08-thumbnail.jpg?920c9825f10c08cac17d20ce46bb8182";